export default function(auth, commit) {
	commit('provider/addPatient', auth)
}
